import { useQueryClient } from "@tanstack/react-query";
import UserService from "./User";
import EventService from "./Events";
import ReportService from "./Report";
import ReportThemeService from "./ReportTheme";
import { client } from "../auth/client";
import TimezoneService from "./TimezoneService";
import RequestService from "./Request";
import AnalysisService from "./Analysis";
import CustomReportService from "./CustomReport";
import GlobalReportService from "./GlobalReport";
import DyadService from "./Dyad";

export type Services = {
  User: ReturnType<typeof UserService>;
  Event: ReturnType<typeof EventService>;
  Report: ReturnType<typeof ReportService>;
  ReportTheme: ReturnType<typeof ReportThemeService>;
  Timezone: ReturnType<typeof TimezoneService>;
  Request: ReturnType<typeof RequestService>;
  Analysis: ReturnType<typeof AnalysisService>;
  CustomReport: ReturnType<typeof CustomReportService>;
  GlobalReport: ReturnType<typeof GlobalReportService>;
  Dyad: ReturnType<typeof DyadService>;
};

export function useServices(): Services {
  const queryClient = useQueryClient();
  return {
    User: UserService(queryClient, client),
    Event: EventService(queryClient, client),
    Report: ReportService(queryClient, client),
    ReportTheme: ReportThemeService(queryClient, client),
    Timezone: TimezoneService(queryClient, client),
    Request: RequestService(queryClient, client),
    Analysis: AnalysisService(queryClient, client),
    CustomReport: CustomReportService(queryClient, client),
    GlobalReport: GlobalReportService(queryClient, client),
    Dyad: DyadService(queryClient, client),
  };
}
